import axios from 'axios';
import React from 'react'
import { connect } from 'react-redux';
import actions from '../actions/index'
import '../src/transferCard.scss'
import KeyForPerson from './key_activation/KeyForPerson';
import StartDate from './key_activation/StartDate';
import ResetDate from './key_activation/ResetDate';
import {invalidToActivate, handedOut} from '../helpers/AbloyKeyHelper';

const csrf_token = $("meta[name=csrf-token]").attr('content');
const axiosClient = axios.create({
  baseUrl: 'http://localhost:3000',
  headers: {
    "x-csrf-token": csrf_token,
    "Content-Type": "application/json"
  }
});

const mapStateToProps = state => {
  return {
    givenKeys: state.givenKeys,
  }
};

const mapDispatchToProps = dispatch => ({
  activateAbloyKey: (leaseId, customerId, apartmentKeyId, abloyKey, startDate) => dispatch(actions.activateAbloyKey(leaseId, customerId, apartmentKeyId, abloyKey, startDate)),
  addLeaseKey: (leaseId, stamp, given, selected) => dispatch(actions.addLeaseKey(leaseId, stamp, given, selected)),
  upsertAbloyKey: (abloyKey) => dispatch(actions.upsertAbloyKey(abloyKey)),
  setKeyUpdatingStatusById: (apartmentKeyId) => dispatch(actions.setKeyUpdatingStatusById(apartmentKeyId, true))
});

class NewKeyItem extends React.Component {
  constructor(props) {
    super(props);

    const lease = this.props.lease
    this.state = {
      loading: false,
      stamp: '',
      customerId: (lease.primary_customers[0] ? lease.primary_customers[0].id : null),
      startDate: (lease.starts_on + 'T08:00'),
      errorMsg: '',
      item: {},
      abloyKey: null,
      normalKey: null
    }
  }

  fetchAbloyKey(leaseId, stamp) {
    const body = JSON.stringify({ search: {stamp: stamp} });
    return axiosClient.post(`/admin/leases/${leaseId}/abloy_keys/search.json`, body);
  }

  editStamp(event) {
    if (event && event.currentTarget) {
      this.setState({ stamp: event.currentTarget.value, abloyKey: null, normalKey: null, errorMsg: '' });
    }
  }

  // function binding https://reactjs.org/docs/faq-functions.html
  editDate = (newDate) => {
    this.setState({ startDate: newDate.toISOString() })
  }

  selectCustomer = (event) => {
    if (event.currentTarget && event.currentTarget.value) {
      this.setState({ customerId: event.currentTarget.value })
    }
  }

  checkKey(leaseId, marking) {
    this.setState({loading: true, abloyKey: null, normalKey: null, errorMsg: ''});
    const keyFound = _.find(this.props.givenKeys, key => {return key.stamp === marking});
    // only if key wasn't found in the keys list -> allow adding.

    if (keyFound) {
      return this.setState({loading: false, errorMsg: 'Tämän niminen avain on jo olemassa'})
    }

    if (!marking || marking.trim() === '') {
      return this.setState({loading: false, errorMsg: 'fill the stamp'})
    }

    const self = this;
    this.fetchAbloyKey(leaseId, marking)
      .then((response)=> {
        const abloyKeys = response.data && response.data.abloy_keys
        if (!abloyKeys || abloyKeys.length == 0) {
          return self.setState({errorMsg: 'Yhtään avainta ei löytynyt', normalKey: marking})
        }
        if (abloyKeys.length > 1) {
          return self.setState({errorMsg: 'There were found more than 1 matches. Please write more accurate stamp.'})
        }

        const abloyKey = abloyKeys[0];
        const msg = invalidToActivate(abloyKey, this.props.lease)
        if (msg) {
          return self.setState({errorMsg: msg})
        }

        if (handedOut(abloyKey, this.props.lease)) {
          return self.setState({errorMsg: 'Tämä avain on jo jaettu yhdelle vuokralaisista, voit nyt lisätä sen vuokrasopimukseen', normalKey: marking})
        }

        self.setState({errorMsg: '', abloyKey: abloyKey, normalKey: null})
      }).then(() => {
        self.setState({loading: false})
      })
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      const lease = this.props.lease;
      this.checkKey(lease.id, this.state.stamp)
    }
  }

  activateAbloyKey() {
    const leaseId    = this.props.lease.id
    const abloyKey   = this.state.abloyKey

    const { customerId, startDate, stamp } = this.state
    this.setState({stamp: '', abloyKey: null })

    abloyKey.is_busy = true
    abloyKey.key_holder_identity = 'loas-' + customerId
    abloyKey.validity = { from: this.state.startDate }

    this.props.upsertAbloyKey(abloyKey)
    const self = this;
    return this.props.addLeaseKey(leaseId, stamp, true).then(()=> {
      const apartmentKey = _.find(self.props.givenKeys, key => {return key.stamp === stamp});
      self.props.setKeyUpdatingStatusById(apartmentKey.id)
      self.props.activateAbloyKey(leaseId, customerId, apartmentKey.id, abloyKey, startDate)
    })
  };

  addNormalKey() {
    const leaseId = this.props.lease.id

    this.setState({stamp: '', abloyKey: null, normalKey: null, errorMsg: '' })

    this.props.addLeaseKey(leaseId, this.state.stamp, true, true)
  }

  abloyKeyDetails() {
    const lease    = this.props.lease
    const abloyKey = this.state.abloyKey

    if (!abloyKey) { return }

    return (
      <div className="card-keys-access">
        <div className="card-row">
          <KeyForPerson customers={lease.primary_customers} currentCustomerId={this.state.customerId} selectCustomer={this.selectCustomer}/>
          <StartDate startDate={this.state.startDate} editDate={this.editDate}/>
          <ResetDate defaultDate={(this.props.lease.starts_on + 'T08:00')} editDate={this.editDate}/>
        </div>
        <button className="btn min-width" onClick={() => this.activateAbloyKey()}>Aktivoi avain</button>
      </div>
    )
  }

  normalKeyDetails() {
    const normalKey = this.state.normalKey

    if (!normalKey) { return }

    return (<div className="card-keys-access"><button className="btn min-width" onClick={() => this.addNormalKey()}>Lisää avain</button></div>)
  }

  render() {
    const lease = this.props.lease;
    if (!lease || !lease.id) return null;

    return (
      <div className="card-keys-stamp" key={'key_stamp_in_new'}>
        <div className="card-row " style={{display: 'flex', flexDirection: 'row'}}>
          <div className="card-item">
            <p>Avaimen leima</p>
            <div className="">
              <input
                type="text"
                value={this.state.stamp}
                onChange={(event) => this.editStamp(event)}
                onKeyPress={(event) => this.handleKeyPress(event)}
                disabled={this.state.loading ? 'disabled' : null}
              />
            </div>
            {!this.state.loading ? <span className="error-msg">{this.state.errorMsg}</span> : null}
          </div>
          <button
            className="btn min-width btn-action-center"
            disabled={this.state.loading ? 'disabled' : null}
            style={{height: "42px"}}
            onClick={() => this.checkKey(lease.id, this.state.stamp)}
          >
            {(this.state.loading ? 'Odota hetki…' : 'Tarkista avain')}
          </button>
        </div>
        {this.abloyKeyDetails()}
        {this.normalKeyDetails()}
      </div>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewKeyItem)
